// extracted by mini-css-extract-plugin
module.exports = {"rating":"CustomerReviewTile_rating__058XJ","blockquote":"CustomerReviewTile_blockquote__7GOg4"};